"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WelcomeScreen;
var _react = _interopRequireDefault(require("react"));
var _FeatureCards = _interopRequireDefault(require("./FeatureCards"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function WelcomeScreen(_ref) {
  let {
    goldenId,
    firstName,
    onFeatureSelect,
    onPromptSelect,
    mode = 'sidebar'
  } = _ref;
  const isStandalone = mode === 'standalone';
  if (isStandalone) {
    return (0, _jsxRuntime.jsxs)("div", {
      style: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: '56px 24px 32px',
        gap: '0',
        overflow: 'hidden',
        minHeight: '480px'
      },
      children: [(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          top: '-80px',
          left: '15%',
          width: '400px',
          height: '400px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(25,118,210,0.12) 0%, transparent 70%)',
          filter: 'blur(60px)',
          pointerEvents: 'none',
          animation: 'sa-floatBlob1 20s ease-in-out infinite'
        }
      }), (0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'absolute',
          bottom: '-60px',
          right: '10%',
          width: '350px',
          height: '350px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(124,58,237,0.10) 0%, transparent 70%)',
          filter: 'blur(60px)',
          pointerEvents: 'none',
          animation: 'sa-floatBlob2 24s ease-in-out infinite'
        }
      }), (0, _jsxRuntime.jsxs)("div", {
        style: {
          animation: 'sa-fadeUp 0.6s ease-out both',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0'
        },
        children: [(() => {
          const hour = new Date().getHours();
          const timeGreeting = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
          return (0, _jsxRuntime.jsxs)("h1", {
            style: {
              fontSize: '34px',
              fontWeight: 600,
              color: '#1e293b',
              margin: 0,
              lineHeight: 1.35,
              letterSpacing: '-0.02em'
            },
            children: [timeGreeting, firstName ? ', ' : ' ', firstName && (0, _jsxRuntime.jsx)("span", {
              style: {
                fontWeight: 800,
                background: 'linear-gradient(135deg, #1976d2 0%, #7c3aed 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              },
              children: firstName
            }), ' ', "\uD83D\uDC4B"]
          });
        })(), (0, _jsxRuntime.jsx)("p", {
          style: {
            fontSize: '20px',
            fontWeight: 400,
            color: '#94a3b8',
            margin: '12px 0 0',
            lineHeight: 1.4,
            letterSpacing: '-0.01em',
            animation: 'sa-fadeUp 0.6s ease-out 0.12s both'
          },
          children: "How can I help you today?"
        })]
      }), (0, _jsxRuntime.jsx)("div", {
        style: {
          width: '80px',
          height: '3px',
          borderRadius: '2px',
          marginTop: '18px',
          background: 'linear-gradient(90deg, #1976d2, #7c3aed, #1976d2)',
          backgroundSize: '200% 100%',
          animation: 'sa-gradientPulse 3s ease-in-out infinite, sa-shimmer 3s linear infinite, sa-fadeUp 0.6s ease-out 0.2s both'
        }
      }), goldenId && (0, _jsxRuntime.jsxs)("span", {
        style: {
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          padding: '5px 14px',
          borderRadius: '24px',
          background: '#ecfdf5',
          color: '#059669',
          fontWeight: 600,
          border: '1px solid #a7f3d0',
          marginTop: '20px',
          animation: 'sa-scaleIn 0.4s ease-out 0.25s both'
        },
        children: [(0, _jsxRuntime.jsxs)("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: [(0, _jsxRuntime.jsx)("path", {
            d: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
          }), (0, _jsxRuntime.jsx)("circle", {
            cx: "12",
            cy: "7",
            r: "4"
          })]
        }), "EID: ", (0, _jsxRuntime.jsx)("strong", {
          children: goldenId
        })]
      }), (0, _jsxRuntime.jsx)("div", {
        style: {
          marginTop: '32px',
          width: '100%'
        },
        children: (0, _jsxRuntime.jsx)(_FeatureCards.default, {
          onSelect: onFeatureSelect,
          mode: mode
        })
      }), (0, _jsxRuntime.jsxs)("p", {
        style: {
          fontSize: '13px',
          color: '#94a3b8',
          marginTop: '24px',
          animation: 'sa-fadeUp 0.6s ease-out 0.9s both',
          display: 'flex',
          alignItems: 'center',
          gap: '2px'
        },
        children: ["Or type a question below to get started", (0, _jsxRuntime.jsx)("span", {
          style: {
            display: 'inline-block',
            width: '2px',
            height: '16px',
            background: '#94a3b8',
            marginLeft: '4px',
            borderRadius: '1px',
            animation: 'sa-blinkCursor 1s step-end infinite'
          }
        })]
      })]
    });
  }
  return (0, _jsxRuntime.jsxs)("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: '32px 16px 16px',
      gap: '0',
      overflow: 'hidden'
    },
    children: [(0, _jsxRuntime.jsx)("div", {
      style: {
        position: 'absolute',
        top: '-40px',
        right: '-30px',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(25,118,210,0.10) 0%, transparent 70%)',
        filter: 'blur(40px)',
        pointerEvents: 'none',
        animation: 'sa-floatBlob1 18s ease-in-out infinite'
      }
    }), (0, _jsxRuntime.jsx)("div", {
      style: {
        position: 'absolute',
        bottom: '-30px',
        left: '-20px',
        width: '160px',
        height: '160px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(124,58,237,0.08) 0%, transparent 70%)',
        filter: 'blur(40px)',
        pointerEvents: 'none',
        animation: 'sa-floatBlob2 22s ease-in-out infinite'
      }
    }), (0, _jsxRuntime.jsxs)("div", {
      style: {
        animation: 'sa-fadeUp 0.5s ease-out both',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0'
      },
      children: [(() => {
        const hour = new Date().getHours();
        const timeGreeting = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
        return (0, _jsxRuntime.jsxs)("h2", {
          style: {
            fontSize: '20px',
            fontWeight: 600,
            color: '#1e293b',
            margin: 0,
            lineHeight: 1.35,
            letterSpacing: '-0.02em'
          },
          children: [timeGreeting, firstName ? ', ' : ' ', firstName && (0, _jsxRuntime.jsx)("span", {
            style: {
              fontWeight: 800,
              background: 'linear-gradient(135deg, #1976d2 0%, #7c3aed 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            },
            children: firstName
          }), ' ', "\uD83D\uDC4B"]
        });
      })(), (0, _jsxRuntime.jsx)("p", {
        style: {
          fontSize: '14px',
          fontWeight: 400,
          color: '#94a3b8',
          margin: '8px 0 0',
          lineHeight: 1.4,
          animation: 'sa-fadeUp 0.5s ease-out 0.1s both'
        },
        children: "How can I help you today?"
      })]
    }), (0, _jsxRuntime.jsx)("div", {
      style: {
        width: '60px',
        height: '2px',
        borderRadius: '1px',
        marginTop: '14px',
        background: 'linear-gradient(90deg, #1976d2, #7c3aed, #1976d2)',
        backgroundSize: '200% 100%',
        animation: 'sa-gradientPulse 3s ease-in-out infinite, sa-shimmer 3s linear infinite, sa-fadeUp 0.5s ease-out 0.18s both'
      }
    }), goldenId && (0, _jsxRuntime.jsxs)("span", {
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        fontSize: '11px',
        padding: '3px 10px',
        borderRadius: '16px',
        background: '#ecfdf5',
        color: '#059669',
        fontWeight: 600,
        border: '1px solid #a7f3d0',
        marginTop: '8px',
        animation: 'sa-scaleIn 0.4s ease-out 0.35s both'
      },
      children: [(0, _jsxRuntime.jsxs)("svg", {
        width: "11",
        height: "11",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [(0, _jsxRuntime.jsx)("path", {
          d: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
        }), (0, _jsxRuntime.jsx)("circle", {
          cx: "12",
          cy: "7",
          r: "4"
        })]
      }), "EID: ", (0, _jsxRuntime.jsx)("strong", {
        children: goldenId
      })]
    }), (0, _jsxRuntime.jsx)("div", {
      style: {
        marginTop: '16px',
        width: '100%'
      },
      children: (0, _jsxRuntime.jsx)(_FeatureCards.default, {
        onSelect: onFeatureSelect
      })
    }), (0, _jsxRuntime.jsxs)("p", {
      style: {
        fontSize: '11px',
        color: '#94a3b8',
        marginTop: '12px',
        animation: 'sa-fadeUp 0.5s ease-out 0.75s both',
        display: 'flex',
        alignItems: 'center',
        gap: '2px'
      },
      children: ["Or type your question below", (0, _jsxRuntime.jsx)("span", {
        style: {
          display: 'inline-block',
          width: '1.5px',
          height: '12px',
          background: '#94a3b8',
          marginLeft: '3px',
          borderRadius: '1px',
          animation: 'sa-blinkCursor 1s step-end infinite'
        }
      })]
    })]
  });
}